import { useEffect, useState } from 'react';
import { callAPI } from '../utils/apiUtils';
import { apiUrls } from '../utils/apiUrls';
import { UPFRONT_FLAG_KEY, isUpfrontEnabledStored } from '../utils/upfrontSetup';

/**
 * The 'Customer details first (takeaway & delivery)' POS setting (Settings page, ConfigsController::POS_SETTINGS
 * 'upfront_order_setup'): a restaurant-wide switch kept on the server, OFF by default. The last answer is kept on this device so
 * the Takeaway / Delivery tab behaves the right way straight away on the next visit; until a device has heard otherwise it is off,
 * so the usual flow is what runs. When the request fails the stored answer stays; when the API answers without the setting (an API
 * that does not have it yet) it is treated as off.
 */
export default function useUpfrontOrderSetting() {
  const [enabled, setEnabled] = useState(isUpfrontEnabledStored);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await callAPI(apiUrls.POS_SETTINGS_GET, {}, 'GET', null, {}, {}, false);
        const list = res?.data?.data;
        if (!Array.isArray(list) || cancelled) return;
        const setting = list.find((s) => s.key === UPFRONT_FLAG_KEY);
        const on = !!(setting && setting.value);
        try {
          window.localStorage.setItem(UPFRONT_FLAG_KEY, on ? '1' : '0');
        } catch {
          // storage blocked: the answer still applies to this visit
        }
        setEnabled(on);
      } catch {
        // keep what the device already has
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { enabled };
}
